import React from "react";
import {useDynamicForm} from "./core/DynamicForm";
import {DynamicPageDrawer} from "./components/DynamicPageDrawer";

export function DynamicFormLoader() {
    const {formData} = useDynamicForm()

    return (
        formData != null ? <DynamicPageDrawer/> : <></>
    )
}